module.exports = __webpack_public_path__ + "img/synagro.3b7b0cea.png";